import CircularProgress from "@material-ui/core/CircularProgress";
import makeStyles from "@material-ui/core/styles/makeStyles";
import * as PropTypes from "prop-types";
import React from "react";
import clsx from "clsx";
import {Container} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    centerContainer: {
        margin: "0 auto",
        paddingRight: theme.spacing(3),
        paddingLeft: theme.spacing(3),
        [theme.breakpoints.up("sm")]: {
            paddingRight: theme.spacing(0),
            paddingLeft: theme.spacing(0),
        },
    },
    loading: {
        width: "100%",
        marginTop: "10%",
        textAlign: "center"
    },
    mobile: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2)
    }
}));

const CenterContainer = ({
    maxWidth,
    loading,
    className,
    children,
}) => {

    const classes = useStyles();


    return (
        <Container
            style={{"maxWidth": maxWidth}}
            className={clsx(
                className,
                classes.centerContainer
            )}
        >

            {children && (
                <>
                    {loading ? (
                        <div className={classes.loading}>
                            <CircularProgress size={80}/>
                        </div>
                    ) : (
                        children
                    )}

                </>
            )}

        </Container>
    );
};

CenterContainer.defaultProps = {
    maxWidth: 625,
    loading: false
};

CenterContainer.propTypes = {
    maxWidth: PropTypes.number,
    loading: PropTypes.bool,
    children: PropTypes.any,
    className: PropTypes.string,
};

export default CenterContainer;
